/* global js_config */

/**
 * This class holds a copy of the config from configInfo.php : js_config.
 */
export class GlobalConfigData {
    /**
     * Constructs a GlobalConfigData class instance.
     *
     * @param {any} data The array of config data from configInfo.php : js_config.
     */
    constructor(data) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }
    }
}

// Invoke a simple singleton pattern, with an external accessor.
let global_config_data = null;
export function config() {
    if (!global_config_data) {
        // Simply creates the config data instance if it doesn't exist yet.
        // NOTE: js_config is a global defined in the main init tpl.
        global_config_data = new GlobalConfigData(js_config);
    }

    // Returns the "static" copy of the class instance.
    return global_config_data;
}
